// ════════════════════════════════════════════════════════════════════════
// DialoguePracticePage.tsx — Visor genérico de diálogos bilingües
// ════════════════════════════════════════════════════════════════════════
// Reutiliza los mismos estilos de InterviewPracticePage (turnos, colores por
// hablante) para cualquier diálogo de dialogues.ts, identificado por :slug.
// Un turno puede tener varios párrafos separados por '\n\n'.
// ════════════════════════════════════════════════════════════════════════

import { useParams, Link } from 'react-router-dom';
import { DashboardLayout } from '../layouts/DashboardLayout/DashboardLayout';
import { AppSidebarMenu } from '../components/AppSidebarMenu/AppSidebarMenu';
import { findDialogue } from '../data/dialogues';
import styles from './InterviewPracticePage.module.css';

function Paragraphs({ text, className }: { text: string; className: string }) {
  return (
    <>
      {text.split('\n\n').map((para, i) => (
        <p key={i} className={className} style={i > 0 ? { marginTop: '0.5rem' } : undefined}>
          {para}
        </p>
      ))}
    </>
  );
}

export default function DialoguePracticePage() {
  const { slug } = useParams<{ slug: string }>();
  const dialogue = findDialogue(slug);

  if (!dialogue) {
    return (
      <DashboardLayout.Root>
        <DashboardLayout.Sidebar>
          <AppSidebarMenu />
        </DashboardLayout.Sidebar>
        <DashboardLayout.Content>
          <h1 className={styles.pageTitle}>Diálogo no encontrado</h1>
          <Link to="/dashboard/leads">Volver al panel</Link>
        </DashboardLayout.Content>
      </DashboardLayout.Root>
    );
  }

  return (
    <DashboardLayout.Root>
      <DashboardLayout.Sidebar>
        <AppSidebarMenu />
      </DashboardLayout.Sidebar>

      <DashboardLayout.Content>
        <div className={styles.pageHeader}>
          <h1 className={styles.pageTitle}>{dialogue.title}</h1>
          <p className={styles.pageSubtitle}>{dialogue.subtitle}</p>
        </div>

        <div className={styles.legend}>
          <span>
            <i className={`${styles.dot} ${styles.dotRecruiter}`} /> Interviewer
          </span>
          <span>
            <i className={`${styles.dot} ${styles.dotCandidate}`} /> Israel
          </span>
        </div>

        {dialogue.parts.map((part, pi) => (
          <div key={pi}>
            {part.label && <h2 className={styles.sectionTitle}>{part.label}</h2>}
            <div className={styles.script}>
              {part.turns.map((turn, ti) => (
                <div
                  key={ti}
                  className={`${styles.turn} ${turn.speaker === 'israel' ? styles.turnCandidate : ''}`}
                >
                  <p
                    className={`${styles.speaker} ${
                      turn.speaker === 'israel' ? styles.speakerCandidate : styles.speakerRecruiter
                    }`}
                  >
                    {turn.speaker === 'israel' ? 'Israel' : 'Interviewer'}
                  </p>
                  <Paragraphs text={turn.en} className={styles.en} />
                  <Paragraphs text={turn.es} className={styles.es} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </DashboardLayout.Content>
    </DashboardLayout.Root>
  );
}
